export default {
  create( _, data ) {
    return {
      taskId:         data.taskId     || "",
      commitmentId:   data.commitmentId     || null,
      duration:       data.duration   || 0
    }
  },

  fields: {
    taskId: {},
    commitmentId: {},
    duration: {}
  }
};
